export { default } from "-!./place-input.js?vue&type=script&lang=js"; export * from "-!./place-input.js?vue&type=script&lang=js"